import { useMutation } from "@tanstack/react-query";
import { MapsAPI } from "../api/maps";

export function useGeocodeAddress() {
  return useMutation({
    mutationFn: (address: string) => MapsAPI.geocode(address),
  });
}

export function useFormatAddress() {
  return useMutation({
    mutationFn: (address: string) => MapsAPI.getFormattedAddress(address),
  });
}
